

const DELIVERY_PROPERTY_LABEL = "delivery time";
const DELIVERY_CODE_PROPERTY = "_delivery";

function parseTimeframe(timeframe) {
  const match = timeframe.match(/(\d+)\s*(?:-\s*(\d+))?\s*(day|week|month)s?/i);

  if (!match) {
    return { minTime: null, maxTime: null, unit: null };
  }

  const [, min, max, unit] = match;

  return {
    minTime: Number(min),
    maxTime: max ? Number(max) : null,
    unit: `${unit.toLowerCase()}s`,
  };
}

function parseDeliveryOption(rawValue) {
  const [title = "", timeframe = ""] = String(rawValue)
    .split("|")
    .map((part) => part.trim());

  return { title, ...parseTimeframe(timeframe) };
}

function addTime(date, amount, unit) {
  const result = new Date(date);

  if (unit === "days") {
    result.setDate(result.getDate() + amount);
    return result;
  }

  if (unit === "weeks") {
    result.setDate(result.getDate() + amount * 7);
    return result;
  }

  const day = result.getDate();

  result.setDate(1);
  result.setMonth(result.getMonth() + amount);

  const daysInTargetMonth = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();

  result.setDate(Math.min(day, daysInTargetMonth));

  return result;
}

function formatShipDate(date) {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function computeShipDateRange({ minTime, maxTime, unit }) {
  if (!unit || !minTime) {
    return null;
  }

  const today = new Date();

  const minDate = formatShipDate(addTime(today, minTime, unit));
  const maxDate = maxTime ? formatShipDate(addTime(today, maxTime, unit)) : null;

  return maxDate ? `${minDate} - ${maxDate}` : minDate;
}

// The "delivery time" line item property for a raw custom.delivery_time option
// ("Title | timeframe | note"), with the estimated ship date counted from today.
// Also used by delivery-date-refresh.js to re-date lines already in the cart.
export function formatDeliveryPropertyValue(rawValue) {
  const parsed = parseDeliveryOption(rawValue);
  const dateRange = computeShipDateRange(parsed);

  return dateRange ? `${parsed.title}: Estimated Ship Date: ${dateRange}` : parsed.title;
}

export function resolveQuickAddProperties({ color, colorCode, styleGroup, deliveryOption } = {}) {
  const properties = {};

  if (color) {
    properties.color = color;
  }

  if (colorCode) {
    properties._color = colorCode;
  }

  if (styleGroup) {
    properties._styleGroup = styleGroup;
  }

  if (deliveryOption) {
    properties[DELIVERY_PROPERTY_LABEL] = formatDeliveryPropertyValue(deliveryOption);
    properties[DELIVERY_CODE_PROPERTY] = parseDeliveryOption(deliveryOption).title;
  }

  return properties;
}
